import React, { useState } from "react";
import { Send } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CncProductionDialog } from "./CncProductionDialog";

export const SendToProductionButton = ({ projectId, packageId = null, packageVersion = null, packageLabel = null, size = "default", testId = "send-to-cnc-button", onPackageLinked }) => {
  const [open, setOpen] = useState(false);
  const [lastRevision, setLastRevision] = useState(null);
  return <>
    <Button type="button" size={size} onClick={() => setOpen(true)} disabled={!projectId && !packageId} title={projectId ? "Preview and send this approved package to CNC" : "Choose the project this approved package belongs to"} className="bg-sky-600 text-white shadow-sm transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-sky-700" data-testid={testId}>
      <Send className="mr-2 h-4 w-4" />Send to CNC{packageVersion ? ` · v${packageVersion}` : ""}{lastRevision ? ` · Rev ${lastRevision.revision}` : ""}
    </Button>
    <CncProductionDialog open={open} onOpenChange={setOpen} projectId={projectId} sourcePackageId={packageId} packageVersion={packageVersion} packageLabel={packageLabel} onPackageLinked={onPackageLinked} onQueued={setLastRevision} />
  </>;
};